import { checkImageValid } from "@/utils/imageUtils";
import { setBackgroundToSvg } from "@/utils/fabricUtils";

export default {
    saveZoneCustomDesign({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("SAVE_ZONE_CUSTOM_DESIGN", payload);
        commit("REMOVE_LOADING_DESIGN");
    },

    deleteZoneCustomDesign({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("DELETE_ZONE_CUSTOM_DESIGN", payload);
        commit("REMOVE_LOADING_DESIGN");
    },

    cleanAllDesign({ commit }) {
        commit("ADD_LOADING_DESIGN");
        commit("DELETE_ALL_ZONE_CUSTOM_DESIGN");
        commit("REMOVE_LOADING_DESIGN");
    },
    updateDesignColor({ commit, state, rootGetters }, colorCode) {
        commit("ADD_LOADING_DESIGN");

        let modifiedDesign = [...state.actualDesign];

        // canvasJson.backgroundImage.src = new url
        modifiedDesign.forEach(design => {
            // console.log("🚀 ~ updateDesignColor ~ design:", design)

            // Calculamos la imagen
            let actualZonaImg = rootGetters["modelo/newComputedImgUrl"](
                {
                    Zona: design.zona,
                    Posicion: design.posicion
                },
                colorCode,
                true
            );

            let actualZonaImgWithSquare = rootGetters[
                "modelo/newComputedImgUrl"
            ](
                {
                    Zona: design.zona,
                    Posicion: design.posicion
                },
                colorCode
            );

            if (
                !checkImageValid(actualZonaImg) &&
                checkImageValid(actualZonaImgWithSquare)
            ) {
                actualZonaImg = actualZonaImgWithSquare;
            }

            if (actualZonaImg && design.mode == "2d") {
                // Actualizamos el json
                design.canvasJson.backgroundImage.src = actualZonaImgWithSquare;
                // Tenemos que modificar el svg
                design.svg = setBackgroundToSvg(design.svg, actualZonaImg);
            }
        });

        if (modifiedDesign.length > 0)
            commit("UPDATE_DESIGN_COLOR", modifiedDesign);
        commit("REMOVE_LOADING_DESIGN");
    },
    addBocetoRepeticion({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("ADD_BOCETO_REPETICION", payload);
        commit("REMOVE_LOADING_DESIGN");
    },
    deleteBocetoRepeticion({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("DELETE_BOCETO_REPETICION", payload);
        commit("REMOVE_LOADING_DESIGN");
    },
    addLoadingDesign({ commit }) {
        commit("ADD_LOADING_DESIGN");
    },
    removeLoadingDesign({ commit }) {
        commit("REMOVE_LOADING_DESIGN");
    },
    // updateParamsHeightAndWidthWithoutUpdatePrice({ commit }, payload) {
    //     commit("ADD_LOADING_DESIGN");
    //     commit("UPDATE_PARAMS_HEIGHT_AND_WIDTH_WITHOUT_UPDATE_PRICE", payload);
    //     commit("REMOVE_LOADING_DESIGN");
    // },
    updateActiveZones({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("UPDATE_ZONES", payload);
        commit("REMOVE_LOADING_DESIGN");
    },
    updateImgInfoCanvas3d({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("UPDATE_IMG_INFO_CANVAS_3D", payload);
        commit("REMOVE_LOADING_DESIGN");
    },
    updateActiveZone3D({ commit }, payload) {
        commit("ADD_LOADING_DESIGN");
        commit("UPDATE_ACTIVE_ZONE_3D", payload);
        commit("REMOVE_LOADING_DESIGN");
    },
    rotateLogoState({ commit }, payload) {
        console.log("🚀 ~ rotateLogoState ~ payload:", payload)
        commit("ADD_LOADING_DESIGN");
        commit("ROTATE_LOGO_STATE", payload);
        commit("REMOVE_LOADING_DESIGN");
    }
}